import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReportBenchmark_Port, IReportBenchmarkMOU } from '../contracts/report-benchmark.contract';
import { BenchmarkService } from '../services';

interface IInitialState {
    List: {
        Result: IReportBenchmarkMOU[] | undefined;
        IsLoading: boolean;
        ErrorMessage: string | undefined;
    };

    VesseTypes: string[];
    MOUs: string[];
    Ports: IReportBenchmark_Port[];
}

const initialState: IInitialState = {
    List: {
        Result: undefined,
        IsLoading: false,
        ErrorMessage: undefined
    },
    VesseTypes: [],
    MOUs: [],
    Ports: []
};

const Fetch = {
    GetReport: createAsyncThunk('benchmark/GetReport', async ({ startDate, endDate, moUs = [], vesselTypes = [] , ports = [] } 
        : { startDate: Date; endDate: Date; moUs?: string[]; vesselTypes?: string[]; ports?: string[] }, { rejectWithValue }) => {
        try {
            const res = await BenchmarkService.getBenchmarkReport(startDate, endDate, moUs, vesselTypes, ports);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }),
    GetVesselTypes: createAsyncThunk('benchmark/GetVesselTypes', async (_, { rejectWithValue }) => {
        try {
            const res = await BenchmarkService.getVesselTypes();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }),
    GetMOUs: createAsyncThunk('benchmark/GetMOUs', async (_, { rejectWithValue }) => {
        try {
            const res = await BenchmarkService.getMOUs();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }),
    GetPorts: createAsyncThunk('benchmark/GetPorts', async (_, { rejectWithValue }) => {
        try {
            const res = await BenchmarkService.getPorts();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const Slice = createSlice({
    name: 'benchmark',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        // GetReport
        builder.addCase(Fetch.GetReport.pending, (state, action: any) => {
            state.List.Result = undefined;
            state.List.IsLoading = true;
            state.List.ErrorMessage = undefined;
        });
        builder.addCase(Fetch.GetReport.fulfilled, (state, action: PayloadAction<IReportBenchmarkMOU[]>) => {
            state.List.Result = action.payload;
            state.List.IsLoading = false;
            state.List.ErrorMessage = undefined;
        });
        builder.addCase(Fetch.GetReport.rejected, (state, action: any) => {
            state.List.Result = undefined;
            state.List.IsLoading = false;
            state.List.ErrorMessage = action.payload?.toString();
        });
        // GetVesselTypes
        builder.addCase(Fetch.GetVesselTypes.fulfilled, (state, action: PayloadAction<string[]>) => {
            state.VesseTypes = action.payload;
        });
        // GetMOUs
        builder.addCase(Fetch.GetMOUs.fulfilled, (state, action: PayloadAction<string[]>) => {
            state.MOUs = action.payload;
        });
        // GetPorts
        builder.addCase(Fetch.GetPorts.fulfilled, (state, action: PayloadAction<IReportBenchmark_Port[]>) => {
            state.Ports = action.payload;
        });
    }
});

export const BenchmarkFetch = Fetch;
export const BenchmarkAction = Slice.actions;
export const BenchmarkReducer = Slice.reducer;
